export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Ищу',
  frontPageProvideTitle: 'Предлагаю',
  frontPagePersonalCenterTitle: 'Профиль',
  login: 'Войти',
  home_chatWithOctopie: 'Понимаем ваши мысли',
  home_chatNeedUnderstood: 'Ваши мысли поняты',
  home_draftBannerTitle: 'Завершите своё сообщение',
  home_draftBannerSubtitle: 'ИИ уже подготовил ваше сообщение — нажмите, чтобы продолжить',
  home_tabHome: 'Главная',

  // App.vue
  appRequirementTitle: 'Мы внимательно относимся к каждому предложению и отзыву',
  appRequirementBtn: 'Отправить',
  appSubmitSuccess: 'Успешно отправлено, спасибо за отзыв',
  appFeedbackLink: 'Предложения/Отзывы',
  mobile_banner_text: 'Для лучшего опыта используйте наше приложение',
  mobile_banner_btn: 'Скачать приложение',

  // Common
  loading: 'Загрузка...',
  confirm: 'Подтвердить',
  cancel: 'Отмена',
  save: 'Сохранить',
  delete: 'Удалить',
  edit: 'Изменить',
  add: 'Добавить',
  search: 'Поиск',
  refresh: 'Обновить',
  change_batch: 'Перемешать',
  back: 'Назад',
  submit: 'Отправить',
  close: 'Закрыть',
  ok: 'ОК',
  yes: 'Да',
  no: 'Нет',
  send: 'Отправить',
  block: 'Заблокировать',
  more: 'Ещё',
  logout: 'Выйти',
  settings: 'Настройки',
  view_guide: 'Открыть руководство',
  feedback: 'Отзывы',
  feedback_title: 'Отзывы',
  feedback_new: 'Новый отзыв',
  feedback_empty: 'Отзывов пока нет',
  feedback_hint: 'Расскажите, что вы думаете...',
  feedback_submit: 'Отправить',
  feedback_submit_success: 'Отзыв успешно отправлен',
  feedback_submit_failed: 'Не удалось отправить отзыв',
  feedback_reply_label: 'Ответ платформы',
  register: 'Регистрация',
  name: 'Имя',
  email: 'Эл. почта',
  mobile: 'Телефон',
  password: 'Пароль',
  verification_code: 'Код подтверждения',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'Все права защищены.',
  footerVersion: 'Версия {version}',
  copy: 'Копировать',
  regenerate: 'Сгенерировать заново',
  generate: 'Сгенерировать',
  contact_now: 'Написать',
  yours: 'ваш',
  xiaoyao_analysis: 'Анализ ИИ',
  brand_name: 'OctoSay',
  anonymous: 'Анонимно',
  no_summary: 'Без summary',
  file: 'Файл',
  discover: 'Обзор',
  discover_title: 'Обзор',
  discover_hotChannels: 'Популярные каналы',
  discover_allChannels: 'Все',
  discover_searchChannel: 'Поиск канала',
  discover_noChannels: 'Каналы не найдены',

  // Messages
  operationSuccess: 'Действие выполнено',
  operationFailed: 'Не удалось выполнить',
  networkError: 'Ошибка сети, попробуйте позже',
  dataLoadingFailed: 'Не удалось загрузить данные',
  noData: 'Нет данных',
  deleteConfirm: 'Вы уверены, что хотите удалить?',
  saveConfirm: 'Вы уверены, что хотите сохранить?',

  // Form Validation
  required: 'Обязательное поле',
  emailInvalid: 'Введите корректный адрес эл. почты',
  phoneInvalid: 'Введите корректный номер телефона',
  passwordTooShort: 'Пароль должен содержать не менее {min} символов',
  passwordMismatch: 'Пароли не совпадают',

  // Time
  today: 'Сегодня',
  yesterday: 'Вчера',
  justNow: 'Только что',
  minutesAgo: '{min} мин. назад',
  hoursAgo: '{hour} ч. назад',
  daysAgo: '{day} дн. назад',

  // Footer
  about: 'О нас',
  footerPrivacy: 'Политика конфиденциальности',
  footerTerms: 'Условия использования',
  footerSupport: 'Помощь и поддержка',

  // Register
  registerAgeConfirm: 'Подтверждаю, что мне не менее 13 лет',
  registerAgeConfirm18: 'Подтверждаю, что мне не менее 18 лет',
  registerTermsPrefix: 'Я прочитал(а) и согласен(на) с ',
  registerTermsAnd: ' и ',
  registerAgeError: 'Подтвердите свой возраст',
  registerTermsError: 'Примите условия и политику конфиденциальности',

  // Chat
  chatPrivacyTip: 'Напишите сообщение в хабе, и ИИ сначала поболтает с вами, чтобы всё прояснить. После подтверждения ваше сообщение и резюме ИИ публикуются вместе, а AI продолжает искать совпадения.',
  aiChat_quickSuggestions: 'Попробуйте сказать',
  aiChat_welcome: "Привет! Расскажи, что ты ищешь.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Детали поняты — опубликуйте, чтобы найти своё совпадение',
  aiChat_readyToPostHint: 'Продолжайте беседу, чтобы в любой момент добавить детали или обновить резюме',
  aiChat_progressStep1: 'Понять детали',
  aiChat_progressStep1Done: 'Детали поняты',
  aiChat_progressStep2: 'Резюме ИИ',
  aiChat_progressStep2Desc: "AI создаёт резюме для подбора пары",
  aiChat_progressStep3: 'Опубликовать в хаб',
  aiChat_progressStep3Desc: 'Опубликуйте и найдите совпадение',
  aiChat_publishExtraHint: 'Введите ваше сообщение для хаба',
  aiChat_publishMsgRequired: 'Обязательно',
  aiChat_publishMsgLabel: 'Ваше сообщение для хаба',
  aiChat_matchSummaryLabel: 'Резюме ИИ',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'Приведённый ниже контент создан ИИ и носит справочный характер.',
  aiChat_publishSuggestionHint: 'Нажмите, чтобы заменить',
  aiChat_allowDirectContact: 'Разрешить прямой контакт',
  aiChat_allowDirectContactDesc: 'Другие могут написать вам напрямую без сопоставления',
  channel_chat_session_publishToChannel: 'Опубликовать в хабе Octo',
  aiChat_newChat: 'Сбросить',

  // Channels / Hubs
  home_tabChannels: 'Хабы Octo',
  channels_title: 'Хабы Octo',
  channels_myChannels: 'Мои хабы',
  channels_discover: 'Обзор',
  channels_noChannels: 'Хабов пока нет',
  channels_noMyGroupsTitle: 'Вы ещё не вступили ни в один хаб',
  channels_noMyGroupsSubtitle: 'Найдите хаб, вступите и начинайте знакомиться',
  channels_searchGroupsBtn: 'Найти хабы',
  channels_loginPrompt: 'Войдите, чтобы посмотреть хабы',
  channels_create: 'Создать хаб Octo',
  channels_search: 'Искать хабы Octo',
  channels_searchMyGroups: 'Искать мои хабы Octo',
  channels_searchHint: 'Поиск',
  channels_searchHintChats: 'Поиск в чатах...',
  channels_searchHintGroups: 'Поиск хабов...',
  channels_searchHintMy: 'Поиск среди моих хабов...',
  channels_joinByCode: 'Вступить по коду',
  channels_joinByCodeTitle: 'Введите код хаба Octo',
  channels_joinByCodeHint: 'Введите код хаба Octo',
  channels_joinByCodeConfirm: 'Вступить',
  channels_joinByCodeNotFound: 'Хаб не найден',
  channels_createNewGroup: 'Создать новый хаб Octo',
  channels_noResults: 'Хабы не найдены',
  channel_detail_join: 'Вступить',
  channel_detail_leave: 'Выйти',
  channel_detail_members: 'участников',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} присоединился к группе',
  channelJoinMsg_twoJoined: '{name1} и {name2} присоединились к группе',
  channelJoinMsg_multiJoined: '{name1}, {name2} и ещё {n} чел. присоединились к группе',
  channelJoinMsg_oneAndMoreJoined: '{name} и ещё {n} чел. присоединились к группе',
  channelJoinMsg_membersJoined: '{n} новых участников в группе',

  // Feed
  channels_feed: 'Чаты',
  channels_groups: 'Хабы',
  feed_related: 'Похожее',
  feed_recommend: 'Рекомендации',
  feed_empty: 'Лента пока пуста, загляните в популярные хабы',
  feed_goToGroup: 'Смотреть в хабе',
  feed_joinGroupAndSendMsg: 'Вступите в хаб и отправьте сообщение',
  channel_detail_channelCode: 'Код хаба Octo',
  channel_detail_invitePhrase: 'Приглашаем в «{name}»\nКод приглашения {code} — откройте приложение для автоматического входа · ИИ сначала уточнит детали и подберёт подходящих людей',
  channel_detail_post: 'Опубликовать в хабе',
  channel_detail_aiHint: "Напишите сообщение в хабе, и AI сначала уточнит детали",
  channel_input_hint: 'Скажите что-нибудь...',
  channel_leave_confirm_message: 'Вы уверены, что хотите покинуть этот хаб? Вы больше не будете получать сообщения хаба.',
  channel_invite_notFound: 'Хаб не найден или ссылка устарела',
  channel_invite_joinBtn: 'Скачать приложение OctoSay',
  channel_invite_hint: 'Скачайте приложение, затем отсканируйте этот QR-код или найдите название хаба, чтобы вступить',
  channel_invite_globalHintTitle: 'Вы собираетесь скачать глобальную версию',
  channel_invite_globalHintIOS: 'Этого приложения может не быть в китайском App Store. Переключитесь на Apple Store вне Китая и найдите OctoSay, или скачайте APK напрямую ниже.',
  channel_invite_globalHintAndroid: 'Google Play может быть недоступен в вашем регионе. Рекомендуем скачать APK напрямую или попробовать Google Play.',
  channel_invite_globalHintDefault: 'Приложения может не быть в местном магазине. Рекомендуем скачать APK напрямую или попробовать App Store.',
  channel_invite_globalBtnAppStore: 'Перейти в App Store',
  channel_invite_globalBtnGooglePlay: 'Перейти в Google Play',
  channel_invite_globalBtnAPK: 'Скачать APK напрямую',
  channel_invite_defaultDesc: 'Вступайте в {name} на OctoSay',
  share: 'Поделиться',
  share_channel: 'Поделиться хабом',
  share_channel_link: 'Поделиться ссылкой',
  channel_detail_inviteCode: 'Код приглашения',
  channel_detail_copyLink: 'Скопировать ссылку',
  share_session_title: 'Публикация в OctoSay',
  share_match_title: 'Совпадение в OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'Посмотрите, что опубликовал {userName} в OctoSay',
  session_share_notFound: 'Публикация не найдена или ссылка устарела',
  session_share_fromChannel: 'Из хаба Octo',
  session_share_downloadBtn: 'Скачать приложение OctoSay',
  session_share_hint: 'Скачайте приложение, чтобы посмотреть публикацию целиком и вступить в хаб',
  session_share_openInApp: 'Открыть в приложении',
  toast_link_copied: 'Ссылка скопирована',
  toast_no_share_data: 'Нечего делиться',
  channels_joinByQR: 'QR-код',
  channels_joinByQRWebHint: 'Веб-версия не поддерживает сканирование QR. Введите код хаба, чтобы вступить.',
  channels_joinByQRTitle: 'Вступить по QR-коду',
  channel_detail_qrCode: 'QR-код',
  channel_detail_qrCodeSave: 'Сохранить изображение',
  channel_detail_qrCodeSaveHint: 'Щёлкните правой кнопкой мыши по изображению, чтобы сохранить',
  channel_detail_qrCodeSaved: 'Сохранено в галерею',
  channel_detail_qrCodeSaveFailed: 'Не удалось сохранить, попробуйте снова',
  channel_detail_locateFailed: 'Не удалось найти сообщение',
  channel_detail_locateError: 'Ошибка при поиске сообщения',
  channel_detail_myMessages: 'Мои сообщения',
  channel_detail_searchMessages: 'Поиск по сообщениям',
  channel_detail_aiChat: 'Чат с AI',
  channel_detail_matchHistory: 'История совпадений',
  channel_create_title: 'Создать хаб Octo',
  channel_create_name: 'Название хаба Octo',
  channel_create_description: 'Описание',
  channel_create_submit: 'Создать',
  channelCreate_aiAssist: 'AI поможет вам создать подходящий хаб',
  channelCreate_nameHint: 'Введите название вашего хаба',
  channelCreate_descHint: 'Опишите, о чём ваш хаб',
  channelCreate_creating: 'Создание...',
  channelCreate_created: 'Хаб создан!',
  channelCreate_failed: 'Не удалось создать хаб',
  channelCreate_welcomeMsg: "Привет! Я помогу вам создать хаб. Расскажите, какой хаб хотите — тему или цель — и я составлю название и описание хаба, а также автоматически создам аватар.",
  channelCreate_aiHint: 'Напиши тему твоего хаба...',
  channelCreate_clarifyingProgress: 'Упорядочиваем тему твоего хаба...',
  channelCreate_readyToCreate: 'Готово к созданию хаба Octo',
  channelCreate_step1: 'Опишите тему',
  channelCreate_step1Done: 'Идея ясна',
  channelCreate_step2: 'Создать хаб Octo',
  channelCreate_confirmBtn: 'Подтвердить создание',
  channelCreate_publicNotice: "Хабы — это публичные пространства, где людям с общими интересами собираться и общаться. Платформа может управлять, обновлять или объединять хабы по мере необходимости. Делитесь этим хабом с теми, кому он может быть интересен.",
  channelCreate_similarGroupsTitle: 'Найдены похожие хабы Octo',
  channelCreate_similarGroupsDesc: 'Эти хабы могут вам подойти',
  channelCreate_exactMatchHint: 'Хаб с точно таким названием уже существует!',
  channelCreate_joinHint: 'Эти существующие хабы могут вам подойти',
  channelCreate_joinExisting: 'Вступить в существующий хаб Octo',
  channelCreate_stillCreate: 'Всё равно создать новый хаб Octo',
  channel_chat_session_comments: 'Комментарии',
  channel_chat_session_commentHint: 'Напишите комментарий...',
  channel_chat_session_sendComment: 'Комментировать',
  channel_chat_session_loadMore: 'Загрузить ещё',
  channel_chat_session_noComments: 'Комментариев пока нет',
  channel_chat_session_deleteComment: 'Удалить',
  channelSearch_title: 'Поиск в хабе',
  channelSearch_placeholder: 'Поиск по сообщениям...',
  channelSearch_onlyMine: 'Только мои публикации',
  channelSearch_tabAllMessages: 'Сообщения хаба',
  channelSearch_tabMyMessages: 'Мои сообщения',
  chatMsgSearch_placeholder: 'Поиск по сообщениям',
  chatMsgSearch_tabMsgs: 'Сообщения',
  chatMsgSearch_tabContacts: 'Контакты',
  chatMsgSearch_emptyPrompt: 'Введите ключевые слова для поиска сообщений',
  chatMsgSearch_tooShort: 'Введите минимум 2 символа для поиска',
  chatMsgSearch_contactEmptyPrompt: 'Введите имя пользователя или эл. почту для поиска контактов',
  chatMsgSearch_noContacts: 'Подходящих контактов нет',
  chatMsgSearch_inChatPlaceholder: 'Поиск в этом чате',
  channelHistory_title: 'История',
  channelHistory_myMessages: 'Мои сообщения',
  channelHistory_loadMore: 'Загрузить ещё',
  channel_settings_push: 'Уведомления хаба Octo',
  channel_settings_commentPush: 'Уведомления о комментариях',
  channel_settings_likePush: 'Уведомления о лайках',
  channel_settings_receiveNotifications: 'Получать уведомления',
  channel_settings_directContact: 'Разрешить прямой контакт',
  session_published: 'Опубликовано',
  session_publishFailed: 'Не удалось опубликовать',
  session_setDirectContactSuccess: 'Настройка сохранена',
  session_setDirectContactFailed: 'Не удалось сохранить настройку',
  session_setPrivate: 'Сделать личным',
  session_setPublic: 'Сделать публичным',
  session_pauseMatching: 'Приостановить подбор',
  session_resumeMatching: 'Возобновить подбор',
  session_matchPausedToast: 'Подбор на паузе',
  session_matchResumedToast: 'Подбор возобновлён',
  match_matchingPausedTitle: 'Подбор на паузе',
  match_reasonTag: 'Причина подбора',
  match_matchingPausedHint: 'Возобновить подбор можно в любой момент.',
  session_confirmSetPrivate: 'Сделать этот контент личным? Другие пользователи не смогут его видеть.',
  session_messageIsPrivate: 'Это личное сообщение',
  chatSessionComment_replyHint: 'Напишите комментарий...',
  chatSessionComment_reply: 'Комментарий',
  chatSessionComment_count: '{n} комментарий | {n} комментария | {n} комментариев',
  chatSessionMatch_count: '{n} совпадение | {n} совпадения | {n} совпадений',
  chatSessionComment_replyTo: 'Ответить',
  chatSessionComment_inputHint: 'Напишите комментарий...',
  chatSessionComment_send: 'Отправить',
  chatSessionComment_delete: 'Удалить',
  chatSessionComment_deleteConfirm: 'Вы уверены, что хотите удалить этот комментарий?',
  chatSessionComment_loadMore: 'Загрузить ещё',
  chatSessionComment_noMore: 'Комментариев больше нет',
  chatSessionComment_loginToComment: 'Войдите, чтобы комментировать',
  chatSessionComment_viewEarlier: 'Посмотреть предыдущие ответы ({n})',
  chatSessionLike_like: 'Нравится',
  chatSessionLike_liked: 'Оценено',
  chatSessionLike_count: 'нравится',
  chatSessionBookmark_bookmark: 'Сохранить',
  chatSessionBookmark_bookmarked: 'Сохранено',
  chatSessionMatch_viewMatches: 'Посмотреть совпадения',
  chatSessionMatch_matchHistory: 'История совпадений',
  chatSessionMatch_noMatches: 'Совпадений пока нет',
  channel_match_achievement: 'Успешно сопоставлено публикаций: {count}',
  channel_match_achievement_view: 'Смотреть →',
  channel_matchHistory_title: 'История сопоставлений канала',
  chatSessionMatch_matchedAt: 'Совпадение в {time}',
  discover_userMsgLabel: 'Пользователь сказал',
  common_loading: 'Загрузка...',
  common_sending: 'Отправка...',
  common_error: 'Ошибка',
  common_success: 'Успешно',
  common_me: 'Я',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "ИИ уточняет ваш запрос, чтобы каждое отправленное сообщение сработало; после публикации он продолжит подбирать совпадения",
  aiChat_clarifyingAlmostDone: 'Почти готово, подтвердите, пожалуйста',
  aiChat_clarifyingOneMore: 'Остался примерно 1 вопрос, и вы сможете опубликовать',
  aiChat_clarifyingRemaining: 'Осталось примерно {count} раундов, совсем скоро',
  aiChat_clarifyingEvaluating: 'Оцениваем прогресс...',
  aiChat_setPublicMatch: 'Сделать публичным и искать совпадения',
  aiChat_needsClarifiedPublic: "Теперь я вас понимаю. После подтверждения и публикации AI будет постоянно подбирать пары.\nВ любой момент можете рассказать больше деталей.",
  aiChat_needsClarifiedPrivate: 'Понял! Сделайте публичным, и я продолжу искать для вас совпадения!\nРасскажите больше деталей в любой момент.',
  aiChat_setPublicTitle: 'Сделать публичным',
  aiChat_setPublicMessage: 'Ваш контент будет виден другим, чтобы OctoSay нашёл для вас подходящие совпадения.\n\nКакая информация будет передана:\n• Имя пользователя и аватар\n• Резюме вашего контента\n• Содержание беседы (видно в разделе «Обзор»)\n\nВы можете в любой момент снова сделать его личным.',
  aiChat_findMatches: 'Посмотреть результат сопоставления',
  aiChat_publishing: 'Публикация...',
  aiChat_matchSectionTitle: 'Твоё сообщение больше всего подходит этим группам — нажми, чтобы опубликовать',
  aiChat_joinedBadge: 'Участник',
  aiChat_matchSectionEmpty: 'Пока нет групп с хорошим совпадением — можно создать новую группу и опубликовать там',
  aiChat_suggestPublishCreateNew: 'Создать новую группу',
  aiChat_repickChannel: 'Сменить группу',
  aiChat_creatingChannelTitle: 'Подходящая группа не найдена — создаём новую',
  aiChat_creatingChannelHint: 'Создаём группу под ваш запрос, затем сразу перейдём к публикации — обычно 10–30 секунд',
  aiChat_publishToChannelHint: 'Будет опубликовано в «{name}»',
  aiChat_pickChannelTitle: 'Выберите группу для публикации',
  aiChat_matchingChannelTitle: 'Подбираем подходящую группу',
  aiChat_matchingChannelHint: 'ИИ ищет по вашему запросу — обычно от нескольких секунд до полминуты',
  aiChat_matchUnavailableTitle: 'Рекомендации недоступны',
  aiChat_matchUnavailableHint: 'Поищите группу ниже или закройте и откройте публикацию заново',
  aiChat_waitSlowHint: 'Дольше обычного, но всё ещё в работе — подождите ещё немного или поищите группу ниже',
  aiChat_creatingSlowHint: 'Создание идёт дольше обычного, но всё в процессе — подождите ещё немного; сразу после этого начнётся публикация',
  aiChat_pickChannelEmptyHint: 'Подходящие группы не найдены. Создайте новую группу и опубликуйте сообщение',
  aiChat_loadMore: 'Загрузить ещё',
  sidebar_publish: 'Опубликовать',
  chat_selectLocationOnMap: 'Выберите место на карте',

  // App.vue new
  placeholder_email: 'Введите эл. почту',
  placeholder_mobile: 'Введите номер телефона',
  placeholder_password: 'Введите пароль',
  placeholder_name: 'Введите ваше имя',
  random_nickname: 'Случайный',
  placeholder_verification_code: 'Введите код подтверждения',
  sending: 'Отправка...',
  registering: 'Регистрация...',
  send_code: 'Отправить код',
  retry_in_seconds: 'Повтор через {countdown} с',
  toast_enter_email: 'Введите эл. почту',
  toast_enter_mobile: 'Введите номер телефона',
  toast_invalid_email: 'Введите корректный формат эл. почты',
  toast_invalid_mobile: 'Введите корректный номер телефона',
  toast_send_code_failed: 'Не удалось отправить код подтверждения',
  toast_code_sent: 'Код подтверждения отправлен на эл. почту',
  toast_code_sent_sms: 'Код подтверждения отправлен на телефон',
  toast_send_code_error: 'Не удалось отправить код подтверждения, попробуйте позже',
  toast_fill_all_fields: 'Заполните все поля',
  toast_login_failed: 'Не удалось войти',
  toast_login_success: 'Вы вошли',
  oauthOr: 'или',
  toast_oauth_login_failed: 'Не удалось войти через Google',
  toast_oauth_login_error: 'Ошибка входа через Google, попробуйте снова',
  toast_login_error: 'Не удалось войти, попробуйте позже',
  toast_register_failed: 'Не удалось зарегистрироваться',
  toast_register_success: 'Регистрация успешна',
  toast_register_error: 'Не удалось зарегистрироваться, попробуйте позже',

  // AdBanner.vue
  ad: 'Реклама',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'Перед подключением',
  contactAd_gateSubtitle: 'Эта короткая пауза позволяет OctoSay оставаться бесплатным — спасибо за поддержку!',
  contactAd_waitBtn: 'Продолжить через {sec} с',
  contactAd_continueBtn: 'Перейти к чату',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Чат',

  // AiMatch.vue
  ai_welcome_msg: 'Привет, я AI. Расскажи, что у тебя на уме — компания, партнёр, обмен навыками или ЧТО УГОДНО.',
  default_username: 'Пользователь',

  // AvatarCropDialog.vue
  crop_hint: 'Сожмите пальцы для масштаба, перетащите для выравнивания',
  toast_crop_failed: 'Не удалось обрезать изображение',

  // ChatBox.vue
  loading_match_info: 'Загрузка информации о совпадении...',
  view_match_details: 'Посмотреть детали совпадения',
  step_clarify_needs: 'Уточнить',
  step_ai_matching: 'Опубликовать в хабе',
  step_connect: 'Сопоставление ИИ',
  make_private: 'Сделать личным',
  setting: 'Настраиваем...',
  action_photo: 'Фото',
  action_file: 'Файл',
  action_video: 'Видео',
  action_location: 'Местоположение',
  hint_get_app: 'Скачайте приложение, чтобы оставаться на связи',
  match_finding_title: 'Ваши совпадения',
  match_finding_subtitle: 'AI продолжает искать совпадения для вас',
  match_time_hint: 'Обычно это занимает 1–2 минуты',
  match_result_stats: 'Найдено лучших совпадений: {matched}{interested}',
  match_tap_to_connect: 'Нажмите, чтобы начать разговор',
  match_channel_hint: 'Подбираем в хабе <strong>#{channel}</strong>. В приоритете — тот же хаб, но при необходимости могут быть и другие хабы.',
  label_perfect_match: 'Лучшее совпадение',
  label_worth_a_look: 'Стоит взглянуть',
  match_no_result_title: 'Ещё ищем совпадения для вас',
  match_no_result_desc: 'Поделитесь бо́льшим количеством деталей, чтобы OctoSay нашёл подходящие совпадения. Установите приложение, чтобы получать уведомления о совпадениях.',
  go_back: 'Назад',
  no_public_requirements: 'Публичных публикаций пока нет',
  channelEmpty_title: 'Здесь пока тихо',
  channelEmpty_subtitle: 'Будьте первым, кто поделится мыслями',
  channelEmpty_hint: "Напишите свои мысли, и AI поможет уточнить детали и продолжит подбор пар, чтобы ваше сообщение не затерялось",
  channelEmpty_action: 'Поделитесь своими мыслями',
  stay_connected: 'Оставайтесь на связи',
  download_app_desc: 'Скачайте приложение, чтобы общаться и мгновенно получать уведомления, когда кто-то свяжется с вами!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'APK напрямую',
  match_history: 'История совпадений',
  no_match_history: 'Истории совпадений пока нет',
  finding_matches: 'AI продолжает искать совпадения — после публикации сообщения в хабе',
  discover_connect_hint: 'Вы сможете переписываться после совпадения!',
  match_initializing: 'Инициализация...',
  placeholder_login_to_chat: 'войдите и расскажите, что у вас на уме',
  toast_need_clear: 'Ваши мысли ясны!',
  toast_ai_responding: 'AI отвечает, подождите...',
  toast_uploading_image: 'Загружаем изображение, подождите...',
  toast_uploading_file: 'Загружаем файл, подождите...',
  toast_max_photos: 'Максимум {max} фото',
  toast_uploading: 'Загрузка, подождите...',
  toast_file_too_large: '{name} превышает лимит 5 МБ',
  toast_video_too_large: '{name} превышает лимит 20 МБ',
  toast_video_processing: 'Видео обрабатывается, подождите...',
  toast_upload_link_failed: 'Не удалось получить ссылку для загрузки',
  analyzing_image: 'Анализируем изображение...',
  toast_location_confirmed: 'Местоположение подтверждено',
  toast_location_selected: 'Местоположение выбрано',
  toast_enter_search: 'Введите поисковый запрос',
  toast_search_failed: 'Поиск не удался',
  toast_no_locations: 'Места не найдены',
  toast_search_error: 'Поиск не удался, попробуйте снова',
  toast_located_at: 'Найдено: {address}',
  toast_shared_finding: 'Опубликовано! Ищем совпадения...',
  toast_update_failed: 'Не удалось обновить',
  toast_set_private: 'Сделано личным',
  toast_no_matches: 'Совпадений не найдено',
  toast_matches_found: 'Найдено лучших совпадений: {count}',
  toast_start_conversation_first: 'Сначала начните разговор',
  toast_load_history_failed: 'Не удалось загрузить историю совпадений',
  toast_ai_timeout: 'AI не ответил вовремя, попробуйте снова',
  toast_message_blocked: 'Сообщение заблокировано',
  network_disconnected: 'Сеть отключена',
  toast_publish_success: 'Опубликовано в хабе!',
  toast_publish_failed: 'Не удалось опубликовать в хабе',

  // ChatMsgList.vue
  collapse_thinking: 'свернуть рассуждения',
  expand_thinking: 'развернуть рассуждения',
  thinking: 'думает',
  select_date: 'Выбрать дату',
  selected_location: 'Выбранное местоположение',
  msg_blocked: 'Заблокировано',
  retry: 'Повторить',
  msg_read: 'Прочитано',
  msg_sent: 'Отправлено',
  msg_unread: 'Не прочитано',
  label_start_datetime: 'Дата и время начала:',
  label_end_datetime: 'Дата и время окончания:',
  toast_select_start_datetime: 'Выберите дату и время начала',
  toast_end_before_start: 'Дата и время окончания не могут быть раньше начала',
  report_message: 'Пожаловаться на сообщение',
  block_user: 'Заблокировать пользователя',
  msg_revoke: 'Отозвать',
  msg_quote: 'Цитировать',
  msg_revoked_self: 'Вы отозвали сообщение',
  msg_revoked_other: 'Собеседник отозвал сообщение',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Сообщение отозвано',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'Это сообщение было отозвано платформой из-за нарушения правил',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Сообщение отозвано',
  toast_revoke_failed: 'Не удалось отозвать сообщение',
  toast_load_data_failed: 'Не удалось загрузить данные, обновите страницу.',
  toast_file_url_missing: 'Ссылка на файл не найдена',
  toast_block_success: 'Пользователь успешно заблокирован',
  toast_block_failed: 'Не удалось заблокировать пользователя',

  // ChatSession.vue
  no_more_records: 'записей больше нет.',
  title_needs_clarified: 'Мысли прояснены',
  title_clarifying: 'Проясняем ваши мысли',
  title_public: 'Публично',
  title_private: 'Лично',
  badge_clarified: 'Прояснено',
  badge_clarifying: 'Проясняется',
  badge_only_me: 'Только я',
  badge_expired: 'Истекло',
  title_expired: 'Истекло',
  no_chat_history: 'Истории чата нет',

  // ContactMethods.vue
  block_status_banner: 'Вы заблокировали этого пользователя',
  unblock_user: 'Разблокировать',
  toast_block_missing_id: 'Нельзя заблокировать: нет ID пользователя',
  dialog_block_confirm: 'Вы уверены, что хотите заблокировать {name}? Вы не будете получать от него сообщения.',
  toast_user_blocked: '{name} заблокирован',
  toast_unblock_missing_id: 'Нельзя разблокировать: нет ID пользователя',
  toast_user_unblocked: '{name} разблокирован',

  // BlockedUsers.vue
  blocked_users: 'Заблокированные пользователи',
  blocked_users_empty: 'Нет заблокированных пользователей',
  blocked_users_empty_hint: 'Заблокированные пользователи не смогут отправлять вам сообщения',
  blocked_users_unblock: 'Разблокировать',
  dialog_unblock_confirm: 'После разблокировки пользователь сможет снова отправлять вам сообщения.',
  toast_unblock_success: 'Разблокировано',
  toast_unblock_failed: 'Не удалось разблокировать, попробуйте снова',
  blocked_users_load_failed: 'Не удалось загрузить. Нажмите, чтобы повторить',
  blocked_users_blocked_at: 'Заблокирован {date}',
  blocked_users_unknown_user: 'Неизвестный пользователь',

  // Contacts.vue
  no_connections: 'Сообщений пока нет',
  chat_with: 'Переписка с {name}',
  toast_load_contacts_failed: 'Не удалось загрузить контакты: {msg}',
  toast_load_contacts_error: 'Не удалось загрузить контакты. Обновите и попробуйте снова.',
  time_just_now: 'Только что',
  time_minutes_ago: '{min} мин. назад',
  time_hours_ago: '{hour} ч. назад',
  time_days_ago: '{day} дн. назад',

  // InteractionNotification.vue
  interaction_notification_title: 'Уведомления',
  interaction_notification_subtitle: 'Комментарии и отметки «нравится»',
  interaction_notification_empty: 'Уведомлений пока нет',
  interaction_notification_comment: 'прокомментировал: {content}',
  interaction_notification_like: 'оценил вашу публикацию',
  interaction_notification_reply: 'ответил: {content}',
  interaction_notification_bookmark: 'сохранил вашу публикацию',
  toast_load_notifications_failed: 'Не удалось загрузить уведомления: {msg}',
  toast_load_notifications_error: 'Не удалось загрузить уведомления. Обновите и попробуйте снова.',
  mark_all_read: 'Отметить всё прочитанным',
  toast_mark_all_read_failed: 'Не удалось выполнить, попробуйте снова',
  contacts_dnd: 'Выключить уведомления',
  dnd_enabled: 'Уведомления выключены',
  dnd_disabled: 'Уведомления включены',
  dnd_action_enable: 'Выключить уведомления',
  dnd_action_disable: 'Включить уведомления',

  // Discover.vue
  toast_load_sessions_failed: 'Не удалось загрузить сессии: {msg}',
  toast_load_sessions_error: 'Не удалось загрузить сессии',
  discover_noMessages: 'Сообщений пока нет',

  // EmojiInputArea.vue
  placeholder_default: 'Поделитесь деталями с AI',
  userChat_typeMessage: 'Введите сообщение...',
  select_emoji: 'Выбрать эмодзи',
  badge_new: 'новое',
  channel_search_placeholder: 'Введите канал',
  channel_picker_empty: 'Введите канал',

  // FrontPage.vue
  tab_chat_with_ai: 'Позвольте OctoSay вас понять',
  history_chats: 'История',
  tab_connections: 'Совпадения',
  tab_conversations: 'Сообщения',
  tab_profile: 'Профиль',
  new_session: 'Новое',
  history_tab_chats: 'Мои',
  history_tab_matches: 'Совпадения',
  channels_octosay: 'Хабы Octo',
  tab_matches: 'Совпадения',
  tab_messages: 'Сообщения',

  // Header.vue
  slogan: 'OctoSay — ИИ, который вас понимает и соединяет с нужным человеком',
  app_name: 'OctoSay',
  slogan_short: 'ИИ, который вас понимает и соединяет с нужным человеком',
  slogan_ai: 'ИИ, который вас понимает и соединяет с нужным человеком',
  get_the_app: 'Скачать приложение',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'или найдите OctoSay в магазинах приложений',

  // MapLocationPicker.vue
  placeholder_search_location: 'Поиск места...',
  coords_display: 'Долгота: {lng}, Широта: {lat}',
  toast_no_geolocation: 'Ваш браузер не поддерживает геолокацию',
  toast_location_permission_denied: 'Не удалось определить ваше местоположение, проверьте разрешения на геолокацию',
  loading_address: 'Загружаем адрес...',

  // MatchedSession.vue
  created_at: 'Создано: {time}',
  ai_match_analysis: 'Анализ совпадения от AI',
  error_missing_session_params: 'Отсутствуют обязательные параметры сессии',
  match_private_hint: 'Эта сессия личная. Контент недоступен',

  // PersonalCenter.vue
  label_name: 'Имя:',
  placeholder_enter_name: 'Введите ваше имя',
  label_bio: 'О себе:',
  placeholder_enter_bio: 'Напишите что-нибудь о себе',
  placeholder_bio_empty: 'Расскажите о себе',
  bio: 'О себе',
  delete_account: 'Удалить аккаунт',
  delete_warning: 'Это действие необратимо.',
  delete_data_intro: 'Следующие данные будут удалены безвозвратно:',
  delete_item_profile: 'Информация вашего профиля',
  delete_item_chat: 'История и сессии чатов',
  delete_item_contact: 'Информация о контактах',
  delete_item_all: 'Все связанные данные',
  final_confirmation: 'Финальное подтверждение',
  delete_confirm_prompt: 'Введите "delete" для подтверждения:',
  placeholder_type_delete: 'Введите delete',
  private_token: 'Личный токен',
  token_desc: 'Создайте токен для доступа к API',
  toast_not_logged_in: 'Пользователь не вошёл',
  toast_name_required: 'Имя обязательно',
  toast_save_success: 'Успешно сохранено',
  toast_save_failed: 'Не удалось сохранить',
  toast_image_too_large: 'Изображение превышает лимит 5 МБ',
  toast_avatar_updated: 'Аватар обновлён',
  toast_avatar_failed: 'Не удалось обновить аватар',
  toast_upload_failed: 'Не удалось загрузить',
  toast_token_generated: 'Токен создан',
  toast_token_failed: 'Не удалось создать токен',
  toast_copied: 'Скопировано в буфер обмена',
  toast_copy_failed: 'Не удалось скопировать',
  toast_account_deleted: 'Аккаунт успешно удалён',
  toast_delete_account_failed: 'Не удалось удалить аккаунт',
  toast_logout_success: 'Выход выполнен',
  toast_logout_failed: 'Не удалось выйти',
  profile_tab_messages: 'Сообщения',
  profile_tab_comments: 'Комментарии',
  profile_tab_likes: 'Отметки «нравится»',
  profile_tab_bookmarks: 'Сохранённое',
  profile_empty_messages: 'Сообщений пока нет',
  profile_empty_comments: 'Комментариев пока нет',
  profile_empty_likes: 'Отметок «нравится» пока нет',
  profile_empty_bookmarks: 'Ничего не сохранено',
  profile_reply_to: 'Ответ {name}',
  profile_stats_posts: 'Сообщения',
  profile_stats_comments: 'Комментарии',
  profile_stats_likes: 'Отметки «нравится»',
  profile_joined: 'С нами с {date}',

  // ReportDialog.vue
  report_message_title: 'Пожаловаться на сообщение',
  report_reason_prompt: 'Выберите причину жалобы на это сообщение:',
  report_spam: 'Спам',
  report_harassment: 'Домогательства или травля',
  report_inappropriate: 'Недопустимый контент',
  report_other: 'Другое',
  placeholder_report_desc: 'Опишите проблему (необязательно)',
  toast_select_reason: 'Выберите причину',
  toast_report_success: 'Жалоба успешно отправлена',
  toast_report_failed: 'Не удалось отправить жалобу',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Фото]',
  summary_images: '[Фото×{count}]',
  summary_file: '[Файл]',
  summary_files: '[Файлы×{count}]',
  summary_video: '[Видео]',
  summary_videos: '[Видео×{count}]',
  summary_location: '[Место]',
  summary_locations: '[Места×{count}]',
  summary_emoji: '[Эмодзи]',
  summary_emojis: '[Эмодзи×{count}]',
  summary_voice: '[Голосовое]',
  summary_voices: '[Голосовые×{count}]',
  summary_mixed: '[Смешанное]',
  summary_other: '[Другое]',

  // Voice messages
  voice: 'Голосовое сообщение',
  voice_recording: 'Запись...',
  toast_voice_too_short: 'Слишком короткая запись',
  toast_voice_failed: 'Не удалось отправить голосовое сообщение',
  toast_mic_permission_denied: 'Нет доступа к микрофону. Включите его в настройках браузера',
  toast_recording_not_supported: 'Запись голоса не поддерживается этим браузером',
  voice_load_failed: 'Не удалось загрузить голосовое сообщение',

  // Expire At
  aiChat_expireLine: "Действует до {date}, скажите AI в любой момент, чтобы обновить",
  aiChat_expireExpired: "Срок действия истёк, содержимое больше не видно другим. Скажите AI в любой момент, чтобы обновить срок действия",

  // MatchedSession.vue
  detail: 'Подробнее',

  // Match notification hints
  match_new_result_hint: 'Если появятся новые результаты сопоставления, вы получите письмо. Для лучшего опыта установите приложение и получайте мгновенные уведомления.',

  // Match notification hints
  match_connection_notify_hint: 'Совпадение найдено, уведомление отправлено! Скорее поздоровайтесь!',
  match_continuousMatching: "AI непрерывно подбирает пары для вас",
  match_continuousMatchingHint: 'Сообщим сразу, как только появятся новые совпадения',
  match_continuousMatchingOthers: "AI непрерывно подбирает пары для них",
  match_continuousMatchingOthersHint: 'Новые совпадения будут появляться здесь по мере нахождения',
  match_noResultsTitleOthers: 'Ещё ищем совпадения для этого человека',
  match_noResultsHintOthers: "AI непрерывно подбирает пары для них. Результаты появятся здесь, как только будут найдены.",
  match_newMatchFound: 'Найдено новых совпадений: {n}!',
  match_worth_exploring_hint: 'Решать, писать ли первым, — вам.',

  // Matches filter tags
  filter_all: 'Все',
  filter_best_connection: 'Лучшее совпадение',
  filter_worth_a_look: 'Стоит взглянуть',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay — ИИ, который вас понимает и соединяет с нужным человеком',
  landing_hero_title: 'Напишите в своём хабе — AI сначала всё прояснит, затем вы публикуете и получаете совпадения.',
  landing_hero_subtitle: 'Напишите сообщение, которым хотите поделиться, в хабе Octo. До публикации AI поболтает с вами, чтобы прояснить детали. После вашего подтверждения сообщение и резюме ИИ публикуются вместе, и AI начинает подбирать совпадения.',
  landing_download_on: 'Скачать в',
  landing_get_it_on: 'Доступно в',
  landing_direct_download: 'Прямая загрузка',
  landing_how_title: 'Как это работает',
  landing_step1_title: 'Напишите в хабе',
  landing_step1_desc: 'Напишите сообщение, которым хотите поделиться, в хабе. ИИ сначала поболтает с вами, чтобы прояснить детали, — каждая публикация будет понятной, полезной и готовой к сопоставлению, а не потеряется в шуме.',
  landing_step2_title: 'Подтвердите, опубликуйте и получите совпадения',
  landing_step2_desc: 'После подтверждения ваше исходное сообщение и резюме ИИ публикуются в хабе вместе. Затем ИИ продолжает искать лучшие совпадения, чтобы ваше сообщение не утонуло и не осталось без внимания.',
  landing_step3_title: 'Соединяйтесь и общайтесь',
  landing_step3_desc: 'Когда совпадение найдено, обе стороны видят историю чата друг друга с AI и резюме ИИ. С общим контекстом лед тает легко — просто общайтесь естественно.',
  // Comparison Section
  landing_comparison_title: 'Почему OctoSay?',
  landing_comparison_subtitle: 'Чат в формате хаба, но AI проясняет детали и активно подбирает совпадения.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'Качество контента',
  landing_cmp1_other: 'Поток спама, рекламы и не по теме',
  landing_cmp1_octo: 'Только отобранные ИИ карточки запросов',
  landing_cmp2_label: 'Поиск людей',
  landing_cmp2_other: 'Публикуете и просто ждёте ответов',
  landing_cmp2_octo: 'AI активно подбирает вам людей',
  landing_cmp3_label: 'Уровень шума',
  landing_cmp3_other: 'Сотни сообщений для прокрутки',
  landing_cmp3_octo: 'Ноль шума, каждая публикация важна',
  landing_cmp4_label: 'Начало работы',
  landing_cmp4_other: 'Искать сервер, листать каналы, разбираться самому',
  landing_cmp4_octo: 'Пишете в хабе; AI проясняет и подбирает',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Групповые чаты затоплены рекламой и спамом',
  landing_cmp1_xhs: 'Рекламные посты везде, доверять сложно',
  landing_cmp1_facebook: 'Реклама и кликбейт заполняют ленту',
  landing_cmp1_reddit: 'Спам и посты не по теме повсюду',
  landing_cmp2_wechat: 'Только через контакты и приглашения в группы',
  landing_cmp2_xhs: 'Искать самому и перерывать посты',
  landing_cmp2_facebook: 'Ограничено существующими друзьями и группами',
  landing_cmp2_reddit: 'Самому листать сабреддиты и надеяться на ответы',
  landing_cmp3_wechat: 'Прокручивать сотни сообщений группы',
  landing_cmp3_xhs: 'Лента полна рекомендаций и рекламы',
  landing_cmp3_facebook: 'Рекомендованные посты и реклама без конца',
  landing_cmp3_reddit: 'Сотни комментариев для прокрутки',
  landing_cmp5_label: 'Кто ищет',
  landing_cmp5_wechat: 'Спрашивать по одному и надеяться на удачу',
  landing_cmp5_xhs: 'Публиковать, ждать комментариев и самому фильтровать',
  landing_cmp5_facebook: 'Приходится расспрашивать в группах',
  landing_cmp5_reddit: 'Публиковать, ждать ответов, потом фильтровать',
  landing_cmp5_octo: 'ИИ сам, постоянно и автоматически, находит вам людей',

  landing_features_title: 'Ключевые возможности',
  landing_feature1_title: 'Прояснить перед публикацией',
  landing_feature1_desc: 'Никаких форм. Напишите сообщение в хабе, и AI сначала поболтает с вами, задаст правильные вопросы и по-настоящему поймёт, что вам нужно.',
  landing_feature2_title: 'Чисто, без хаоса',
  landing_feature2_desc: 'Ваше сообщение и резюме ИИ публикуются вместе — OctoSay курирует каждую публикацию: без спама, без потока не по теме, без шума для прокрутки.',
  landing_feature3_title: 'Проактивный подбор',
  landing_feature3_desc: 'После подтверждения, когда ваше сообщение и резюме ИИ выходят в эфир, AI постоянно сканирует хаб в поисках людей, подходящих вашему запросу, — и объясняет, почему.',
  landing_feature4_title: 'Сообщества по темам, ноль шума',
  landing_feature4_desc: 'Вступайте в тематические хабы — спорт, игры, языковой обмен, соседи по квартире — AI проясняет сообщение до публикации, поэтому каждый хаб остаётся чистым и полезным.',
  landing_feature5_title: 'Приватность под защитой',
  landing_feature5_desc: 'После отправки можно сделать сообщение личным, видимым только вам. Полный контроль.',
  landing_feature6_title: 'Осмысленное общение',
  landing_feature6_desc: 'Без шума и отвлекающих факторов — каждое сообщение имеет значение.',
  landing_usecases_title: 'Подходит для любых сценариев',
  landing_usecases_subtitle: 'Что бы ни было у вас на уме, вступайте в тематический хаб — AI возьмёт подбор на себя, чтобы вам не пришлось листать и искать',
  landing_usecase_game: 'Напарник по играм',
  landing_usecase_language: 'Языковой обмен',
  landing_usecase_skill: 'Обмен навыками',
  landing_usecase_roommate: 'Найти соседа по квартире',
  landing_usecase_travel: 'Попутчик',
  landing_usecase_sports: 'Партнёр по спорту',
  landing_usecase_study: 'Партнёр по учёбе',
  landing_usecase_anything: '...или поделитесь чем угодно',
  landing_cta_title: 'Готовы начать?',
  landing_cta_desc: 'Вступайте в тематический хаб, напишите, чем хотите поделиться, дайте AI прояснить детали, затем публикуйте и получайте совпадения с нужными людьми.',
  landing_use_now: 'Начать сейчас',
  landing_groups: 'Хабы',

  // OnboardingPage.vue
  onboarding_skip: 'Пропустить',
  onboarding_next: 'Далее',
  onboarding_getStarted: 'Начать',
  onboarding_step1Title: "Скажите в хабе, что вам нужно",
  onboarding_step1Desc: "Что бы вы ни искали или ни хотели сделать — просто скажите об этом. ИИ поговорит с вами, чтобы уточнить детали, и превратит это в понятную просьбу.",
  onboarding_step2Title: 'Подтвердите, опубликуйте и получите совпадения',
  onboarding_step2Desc: "После того как ваше сообщение опубликовано в хабе, ИИ непрерывно ищет для вас лучшие совпадения, чтобы оно не затерялось и не осталось без внимания.",
  onboarding_step3Title: 'Соединяйтесь и общайтесь',
  onboarding_step3Desc: "Обе стороны видят переписку друг друга с AI и понимают, что тот ищет. С общим контекстом начать разговор легко — просто общайтесь естественно.",

  // ChannelDetail.vue
  channel_image_limit: 'Максимум 1 изображение',

  // ChannelMembers.vue
  channel_members_empty: 'Участников пока нет',
  channel_members_title: 'Участники',
  channel_role_owner: 'Владелец',
  channel_role_admin: 'Админ',
  channel_role_member: 'Участник',

  // Settings.vue
  settings_language: 'Язык',
  settings_language_followSystem: 'Как в системе',

  // ChatBox.vue
  match_interested_suffix: ', {count} стоит взглянуть',

  // ChatBox.vue - Этапы прогресса ИИ-подбора
  match_stage_fetch_chat: 'Получение диалога',
  match_stage_query_expansion: 'Расширение запросов',
  match_stage_semantic_search: 'Семантический поиск',
  match_stage_deep_search: 'Глубокий анализ',
  match_stage_rerank: 'Умный подбор',
  match_stage_refining: 'Оптимизация результатов',
  match_stage_fetch_details: 'Получение деталей',

  // ChannelDetail.vue - Загрузка изображений
  channel_select_image: 'Пожалуйста, выберите файл изображения',
  channel_image_upload_failed: 'Ошибка загрузки изображения, попробуйте снова',
  chatInput_channelSearchHint: "Поиск хабов",
}



// WEBPACK FOOTER //
// ./src/i18n/ru.js